module.exports = __webpack_public_path__ + "img/bee-img-auth-sideimg3.24c42018.png";